// AUTO-GENERATED from config/site-design.json by scripts/generate-site-design.mjs.
// DO NOT EDIT BY HAND. Run `node scripts/generate-site-design.mjs` to regenerate; CI fails on drift.
//
// Which surfaces of the new design prest0.ai itself shows. The demonstration address,
// prest0.ai/prest0design/, shows every surface regardless (src/design/previewPath.ts designShows).

/** Every surface the new design has. */
export type DesignSurface = "home" | "chat" | "about" | "for-enterprise" | "for-lawyers" | "for-individuals" | "pricing" | "legal" | "privacy-policy" | "terms-of-service" | "cookie-policy" | "sms-terms" | "auth" | "auth-action" | "auth-callback" | "accept-invite" | "signup" | "onboarding" | "start" | "team" | "mission" | "insights" | "app" | "trust" | "security" | "demo" | "not-found" | "desktop" | "wallet" | "subscription" | "notifications" | "settings" | "profile" | "organization" | "portal-controls" | "team-roles" | "activity" | "insights-studio" | "integrations" | "top-up" | "terms-update" | "agreement" | "roi" | "roi-calculator" | "solutions" | "file-preview" | "splash" | "band" | "skills" | "justiceisurright" | "preview-3d" | "infrastructure" | "admin-vms" | "moonshot" | "referrals" | "referral-invite" | "referral-dashboard";

export const DESIGN_SURFACES: readonly DesignSurface[] = [
  "home",
  "chat",
  "about",
  "for-enterprise",
  "for-lawyers",
  "for-individuals",
  "pricing",
  "legal",
  "privacy-policy",
  "terms-of-service",
  "cookie-policy",
  "sms-terms",
  "auth",
  "auth-action",
  "auth-callback",
  "accept-invite",
  "signup",
  "onboarding",
  "start",
  "team",
  "mission",
  "insights",
  "app",
  "trust",
  "security",
  "demo",
  "not-found",
  "desktop",
  "wallet",
  "subscription",
  "notifications",
  "settings",
  "profile",
  "organization",
  "portal-controls",
  "team-roles",
  "activity",
  "insights-studio",
  "integrations",
  "top-up",
  "terms-update",
  "agreement",
  "roi",
  "roi-calculator",
  "solutions",
  "file-preview",
  "splash",
  "band",
  "skills",
  "justiceisurright",
  "preview-3d",
  "infrastructure",
  "admin-vms",
  "moonshot",
  "referrals",
  "referral-invite",
  "referral-dashboard",
];

/** The surfaces live on prest0.ai itself. One word per surface; removing it takes that surface back off. */
export const LIVE_ON_PREST0_AI: readonly DesignSurface[] = [
  "home",
  "chat",
  "about",
  "for-enterprise",
  "for-lawyers",
  "for-individuals",
  "pricing",
  "team",
  "mission",
  "legal",
  "privacy-policy",
  "terms-of-service",
  "cookie-policy",
  "trust",
  "security",
  "app",
  "desktop",
  "auth",
  "auth-action",
  "auth-callback",
  "signup",
  "start",
  "accept-invite",
  "wallet",
  "subscription",
  "onboarding",
  "notifications",
  "roi",
  "roi-calculator",
  "solutions",
  "demo",
  "agreement",
  "insights-studio",
  "insights",
  "referrals",
  "referral-invite",
  "referral-dashboard",
];
